import { render, staticRenderFns } from "./title-bar.vue?vue&type=template&id=4b87996a&scoped=true&"
import script from "./title-bar.vue?vue&type=script&lang=js&"
export * from "./title-bar.vue?vue&type=script&lang=js&"
import style0 from "./title-bar.vue?vue&type=style&index=0&id=4b87996a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b87996a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
